import { createContext, useContext, useState, ReactNode } from 'react';
import { BusinessType } from '@/types/onboarding.ts';
interface BusinessTypeDto {
  type: BusinessType;
  details?: string;
}

interface UserProfileDto {
  fullName: string;
  bio?: string;
  avatar?: string;
  phoneNumber?: string;
  /** ISO 3166-1 alpha-2; decides which plan currencies are offered. */
  billingCountry?: string;
}

interface AccountDto {
  name: string;
  description?: string;
  country?: string;
  marketplaceId?: string;
  countryCode?: string;
  /** Canonical IANA timezone (TZ-006 / TZ-008), e.g. "Asia/Kolkata" */
  timezone?: string;
}

interface TrialSubscriptionDto{
  startDate: Date
  endDate: Date
}

export interface OverallOnboardingDto {
  businessType: BusinessTypeDto | undefined | null;
  userProfile: UserProfileDto | undefined | null;
  account: AccountDto | undefined | null;
  trialSubscription: TrialSubscriptionDto | undefined | null;
}

interface OnboardingContextType {
  data: Partial<OverallOnboardingDto>;
  updateData: (values: Partial<OverallOnboardingDto>) => void;
  resetData: () => void;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(
  undefined
);

export const OnboardingProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] = useState<Partial<OverallOnboardingDto>>({});

  const updateData = (values: Partial<OverallOnboardingDto>) => {
    setData((prev) => ({ ...prev, ...values }));
  };

  const resetData = () => setData({});

  return (
    <OnboardingContext.Provider value={{ data, updateData, resetData }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return context;
};
